const API_KEY               = `18852160-36a1004710f1f2896f7bfc714`;
const URL                   = `https://pixabay.com/api/?key=${ API_KEY }`;

export {
    URL
}